import React, { useCallback } from 'react';
import { observer } from 'mobx-react';

import type Trip from '@this/src/domain/trip/trip2';
import { Fetcher } from '@this/src/util';
import { MemoForm } from './memo_form';

type Props = {
  trip: Trip;
};

export const ArrangerMemoField = observer(({ trip }: Props) => {
  const handleArrangerMemoSubmit = useCallback(
    async (memo: string) => {
      await Fetcher.post('/arranger_memos/update_or_create.json', { memo, trip_id: trip.id });
    },
    [trip.id]
  );

  return (
    <div>
      <MemoForm
        inputName="arranger_memo"
        label="対応者メモ"
        initialValue={trip.arrangerMemo?.memo ?? ''}
        onSubmit={handleArrangerMemoSubmit}
        testId="arranger-memo-form"
      />
    </div>
  );
});
